import React from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import "./RichTextEditor.css";

// Self-hosted rich-text editor (Quill). Replaces the cloud TinyMCE editor so
// there's no API key / approved-domain requirement. Stores/returns plain HTML,
// so the public Terms / Privacy / FAQ pages (rendered via dangerouslySetInnerHTML)
// are unaffected.
const TOOLBAR = [
  [{ header: [1, 2, 3, false] }],
  ["bold", "italic", "underline"],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ align: [] }],
  ["link"],
  ["clean"],
];

const RichTextEditor = ({ value, onChange, placeholder }) => (
  <div className="rte-quill">
    <ReactQuill
      theme="snow"
      value={value || ""}
      onChange={(content) => onChange && onChange(content)}
      placeholder={placeholder}
      modules={{ toolbar: TOOLBAR }}
    />
  </div>
);

export default RichTextEditor;
